export default __webpack_public_path__ + "static/media/strip.17008c7b.jpeg";